import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CompareVehicleTrayMap } from 'client/tracking/maps/common/compare-vehicle-tray';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  top_rated_articlesubnav_view_content: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SUBNAV_CONTENT
  ),
  top_rated_articlevehicle_read_more: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.READ_MORE
  ),
  top_rated_articlevehicle_see_more_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),
  top_rated_articlevehicle_see_more_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),
};

export const TopRatedArticleMap = {
  ...CommonMap,
  ...EditorialMap,
  ...CompareVehicleTrayMap,
  ...map,
};
